var emailConfig = (function () {
    function emailConfig() {
        this.emailList = {
            "1": {
                id: 1,
                profilePhoto: "man-photo",
                name: "同事",
                title: "酒店活动手册设计",
                state: 0,
                List: [{
                        t: 1,
                        d: "我们酒店的活动手册设计草案的进度怎么样了？"
                    },
                    {
                        t: 2,
                        d: "这个进度没问题，但是现在有个大问题！"
                    },
                    {
                        t: 1,
                        d: "怎么了？"
                    },
                    {
                        t: 2,
                        d: "我们和网上平台的广告位合约到期了，现在对方不肯与我们续约，这样会影响今年网约房的销量……"
                    },
                    {
                        t: 1,
                        d: "怎么会这样？我们不是上个月就通知法务重新去签署合同了吗？"
                    },
                    {
                        t: 2,
                        d: "法务说没有收到通知邮件。"
                    },
                    {
                        t: 1,
                        d: "这件事情是谁在负责？"
                    },
                    {
                        t: 2,
                        d: "呃，是黎启。"
                    }
                ]
            },
            "2": {
                id: 2,
                profilePhoto: "man-photo",
                name: "死党",
                title: "酒店风格调研",
                state: 0,
                List: [{
                        t: 1,
                        d: "帮个忙，我想做个调研，你喜欢住我们酒店吗？"
                    },
                    {
                        t: 2,
                        d: "额，还好吧，刚开始几次还觉得不错……"
                    },
                    {
                        t: 1,
                        d: "能具体说说我们酒店有什么问题吗？"
                    },
                    {
                        t: 2,
                        d: "老实说，你们酒店的硬件其实还可以，就是10年了，设施设备从没更新过。"
                    },
                    {
                        t: 1,
                        d: "那除了这个之外呢？"
                    },
                    {
                        t: 2,
                        d: "服务也没啥特色。"
                    },
                    {
                        t: 1,
                        d: "你说的特色是像某些酒店的主题式服务吗？"
                    },
                    {
                        t: 2,
                        d: "这倒不是，我是觉得不够贴心，服务不周到……"
                    }
                ]
            },
            "10001": {
                id: 10001,
                name: "高朗",
                isread: false,
                subject: "市场上常见促销方法",
                date: "08:21 AM",
                desc: "上次会议之后，我把目前市场上常见的促销......",
                content: "上次会议之后，我把目前市场上常见的促销方法看了一下，主要有几种：<br/>" +
                    "1.  价格冲击 – 通过调整价格来吸引更多客户选择入住。<br/>" +
                    "2.  套餐活动 – 不仅提供酒店住房，还增加配套的活动，比如说三天养身排毒之旅，或养出玫瑰嫩肌等。<br/>" +
                    "3.  特色营销 – 主打某一种主题或风格，比如说AA酒店，他们就增加了少数民族的风格配饰，针对用户喜好添加软装摆设。<br/>" +
                    "4.  积分兑奖 – 在淡季时入住，客户可以得到更多的积分，一定的积分可以兑换不同的奖品。<br/>" +
                    "我觉得我们酒店可以在2和4上面花点功夫，也想听听你的意见，期待回复。<br/>"
            },
            "10002": {
                id: 10002,
                name: "高朗",
                isread: false,
                subject: "补充信息–建立战略关系",
                date: "08:38 AM",
                desc: "对了，还漏了一件事情和你说，我建议......",
                content: "对了，还漏了一件事情和你说，我建议我们可以和旅行社结成战略性伙伴关系。<br/>" +
                    "比如说，旅行社在淡季为酒店带来多少客户，就能在旺季得到更多的配额。相信为了调剂需求，他们也会配合我们的促销手段。<br/>" +
                    "其实我们还可以和周边的出租车或者网络打车平台合作，他们如果愿意帮忙宣传，我们在后面两个月转入淡季的时候，可能不会失去太多的客户来源。<br/>"
            },
            "10003": {
                id: 10003,
                name: "王立娜",
                isread: false,
                subject: "网约房的紧急事件处理",
                date: "08:45 AM",
                desc: "领导，之前提到关于网约房的事情......",
                content: "目前网站供应商并没有给出明确答复，但他们同意下周和我们一起商讨具体的处理方案。您下周有空吗？我们可以与法务部一同出席该会议。<br/>" +
                    "另外，这件事情也让我有了新的想法。目前在线销售商比较强势，大部分酒店都面临严苛的市场环境，我们可以考虑抱团取暖的方法。<br/>" +
                    "比如说，A酒店联合了B、C、D三家酒店，目前形成了以它为首的四方联盟。E酒店收购了F和G两家酒店。这样，同类型酒店可以迅速扩<br/>" +
                    "大经营规模、聚合会员、整合资源，酒店有更多的议价权，受到在线销售的影响也比较小。<br/>"
            },
            "10004": {
                id: 10004,
                name: "王立娜",
                isread: false,
                subject: "会务预定订单分析",
                date: "09:00 AM",
                desc: "领导，我把近两年来会务预定的订单做了分析......",
                content: "领导，我把近两年来会务预定的订单做了分析。<br/>\n" +
                    "我发现我们会务的顾客群主要是政府机关和大企业等。虽然市场中有一些同类型酒店也以商务会议为主，但是我们酒店位于风景区，这是非常占优势的。<br/>\n" +
                    "我想对于客户来说，一个既能度假旅游，又能举行会议的地方，才是理想之选。<br/>\n" +
                    "另外，我也查看了会务的订单高峰期，通常是在年初或年底，年中的预定量并不多。所以，我建议这次的淡季是否能够主打会议营销？我觉得这可能会是增加营业额的重要手段。<br/>"
            },
            "10005": {
                id: 10005,
                name: "秦飞",
                isread: false,
                subject: "促销活动的执行与沟通",
                date: " 09:12 AM",
                desc: "关于酒店淡季促销活动，你一定要关注活动的执行推进....",
                content: "关于酒店淡季促销活动，你一定要关注活动的执行推进，避免方案制定出来之后，因为客户的沟通不到位而造成损失。<br/>" +
                    "从我的角度来看，你要第一时间和高朗合作，在官网和旅行社公布酒店促销信息，同时利用微博、微信等社交媒体进行传播，建立与客户之间的分享奖励机制，吸引传播。<br/>" +
                    "另外，最好能派足够的人手，在酒店周边的社区、写字楼、商务中心等进行宣传。<br/>" +
                    "还有千万不要忘记动员酒店的员工进行全员销售，但是呢，销售的奖励机制你要好好想想，毕竟现在总部希望我们能够考虑成本问题。<br/>"
            },
            "10011": {
                id: 10011,
                name: "高朗",
                isread: false,
                subject: "用大数据打造人性化住宿服务",
                date: "07:31 AM",
                desc: "随着互联网的不断发展，未来大数据会成为趋势......",
                content: "随着互联网的不断发展，未来大数据会成为趋势，我们也需要利用大数据为我们服务。<br/>" +
                    "我觉得我们需要致力于为入住的消费者提供时尚、贴心、健康、快乐、舒适的酒店住宿体验。<br/>" +
                    "虽然我并不是项目的负责人，但从营销的角度上，我可以贡献一点想法。<br/>" +
                    "1.  营销的本质是满足消费者的需求，而现在消费者的需求是为了满足心理、精神需求。<br/>" +
                    "2.  在成熟市场上，顾客的消费习惯行为已由“目的消费”转为“手段消费”，因此只有做到风格化、个性化，才能获得顾客的心理认同。<br/>" +
                    "3.  资料库的建立是非常有必要的。营销上是信息为王，服务上也应该这样做。拥有充足的顾客资料才能了解他们的需求，是提供个性化服务的基础。<br/>" +
                    "我觉得如果要在酒店的服务上进行系统、全面的升级，并且要得到顾客的喜欢，首先要建立数据库，然后以老客户为基点，抓住老客户，营造好口碑，这样才有持续性进化的能力。<br/>"
            },
            "10012": {
                id: 10012,
                name: "季宁",
                isread: false,
                subject: "提升酒店服务人员的个人形象和素质",
                date: "07:54 AM",
                desc: "领导，根据这段时间来客户的反馈和我自己的观察......",
                content: "&nbsp;&nbsp;领导，根据这段时间来客户的反馈和我自己的观察，我觉得提升团队服务人员的个人形象和素质是当务之急。<br/>" +
                    "&nbsp;&nbsp;酒店的软件质量就是我们的服务水平，虽然我们的酒店开了10年，设备一直没有更新过，但若能提供良好的、令顾客满意的服务，可以在一定程度上弥补硬件方面的不足。<br/>" +
                    "&nbsp;&nbsp;服务人员的个人形象和素质对顾客的情绪有直接的影响。我觉得我们需要尽快组织一系列培训，包括：仪容仪表、文明礼貌和服务态度，提升酒店的档次。<br/>"
            },
            "10013": {
                id: 10013,
                name: "酒店行业协会",
                isread: false,
                subject: "加强酒店的安全管理",
                date: "08:45 AM",
                desc: "鉴于最近在本市发生多起酒店盗窃事件......",
                content: "鉴于最近在本市发生多起酒店盗窃事件，在此我们提醒行业同僚重视酒店内部安全管理问题。<br/>" +
                    "1.  加强对员工的安全教育：<br/>" +
                    "2.  狠抓内部安全管理<br/>" +
                    "3.  配备安全防范设备设施。<br/>" +
                    "4.  建立应急预案和管理规章制度。<br/>"
            },
            "10021": {
                id: 10021,
                name: "客房部主管",
                isread: false,
                subject: "客户满意度持续下降",
                date: "08:58 AM",
                desc: "从客人在住宿后对酒店的反馈留言可以看出他们......",
                content: "从客人在住宿后对酒店的反馈留言可以看出他们的满意度并不高。<br/>" +
                    "三个季度以来，好评率持续下滑，从原来90%，下滑至83%。这是个危险的信号，我们需要及时采取措施来阻止满意度的持续降低。<br/>" +
                    "通过分析，住客对于我们的服务相应速度和质量都不太满意，我觉得可以从这两个方面入手。建议可以通过培训提升员工服务素养，并且加强正确服务理念的宣导：顾客是上帝，不论他们提出什么诉求，我们都应该设法满足。<br/>"
            },
            "10031": {
                id: 10031,
                name: "魏丽",
                isread: false,
                subject: "预产期休假",
                date: "09:01 AM",
                desc: "各位亲爱的伙伴们，鉴于预产期临近，我将于......",
                content: "各位亲爱的伙伴们，鉴于预产期临近，我将于本周五开始正式休假。<br/>" +
                    "工作交接列表请见附件，之后四个月的工作我已经交接给王立娜主管。不过如果大家有什么问题，也可以联系我。<br/>" +
                    "伙伴们，九月初再见咯！<br/>"
            },
            "10032": {
                id: 10032,
                name: "王立娜",
                isread: false,
                subject: "VVIP客户团接待事宜",
                date: "1:43 PM",
                desc: "领导，我想跟您确认下两周VVIP客户团的接待......",
                content: "领导，我想跟您确认下两周VVIP客户团的接待事宜。我知道酒店一直想拿下这个优质客户，所以，我也已经将接待细则做好了，希望这次能给客户留下好印象，未来能给酒店带来更多机会。<br/>" +
                    "<br/>" +
                    "这次接待活动时间紧、任务重，会务团队的人手肯定不够，我希望您能帮忙协调一下，从其他团队抽调4-5个人给我们。谢谢！<br/>"
            },
            "10041": {
                id: 10041,
                name: "高朗",
                isread: false,
                subject: "网约房合同",
                date: "2:12 PM",
                desc: "有件事我需要找你了解情况。我听说网约......",
                content: "有件事我需要找你了解情况。我听说网约房的合作伙伴不肯跟我们续约了，有这回事吗？<br/>" +
                    "网约房是酒店的宣传重点之一，我们在印刷新的宣传手册时，就跟你们部门的黎启确认过续约是没问题的。现在宣传物料都到位了，我才知道合同还没签！<br/>" +
                    "我现在需要一个明确的答案，让我们知道网约房到底能不能宣传。请你在这周五之前务必给我一个答复，谢谢。<br/>"
            },
            "10042": {
                id: 10042,
                name: "秦飞",
                isread: false,
                subject: "黎启离职",
                date: "3:00 PM",
                desc: "员工的去留问题你自己看着办吧......",
                content: "员工的去留问题你自己看着办吧，不用问我，注意不要打乱部门的正常工作节奏。<br/>" +
                    "另外，人员流动可能会影响到团队的士气，这点处理起来要当心。<br/>"
            },
            "20000": {
                id: 20000,
                profilePhoto: "qf-photo",
                name: "秦飞",
                title: "对老客户更需要体现出个性化",
                state: 0,
                List: [{
                        t: 2,
                        d: "刚才我给你转了篇微博推送，里面的内容挺好的。"
                    },
                    {
                        t: 1,
                        d: "我看到了，这当中有个点很打动我，就是对老客户的保留措施。"
                    },
                    {
                        t: 2,
                        d: "没错，我也很喜欢这个观点。老客户的数据是我们酒店的财富，但这个财富之前一直没想好应该要怎么去发挥更大的作用。"
                    },
                    {
                        t: 1,
                        d: "对，看了这个推送，我觉得我们可以把老顾客的信息进行整理，包括姓名、住房偏好、饮食习惯，甚至是宗教信仰等等，这样等下次客人再次入住的时候，我们可以第一时间调用资料，提供让他们满意、贴心的服务。"
                    },
                    {
                        t: 2,
                        d: "是呀，你能这样想，我很欣慰。服务优化这块要多靠你来费心了。"
                    },
                    {
                        t: 1,
                        d: "没问题的，老板，您放心吧!"
                    }
                ]
            },
            "20001": {
                id: 20001,
                profilePhoto: "gl-photo",
                name: "高朗",
                title: "积分兑奖",
                state: 0,
                List: [{
                        t: 2,
                        d: "上次我们开会时提到的“积分兑奖”，你有什么想法吗？"
                    },
                    {
                        t: 1,
                        d: "挺好啊！其实我一直觉得这招能够吸引不少客户，果然营销上还得靠你！"
                    },
                    {
                        t: 2,
                        d: "但是这个活动需要各部门的积极配合与支持，毕竟一旦推出这个活动，就要做出特色。"
                    },
                    {
                        t: 1,
                        d: "我同意。"
                    },
                    {
                        t: 2,
                        d: "我希望我们酒店能够做到客户一旦提出兑换，小宗奖品即时兑换，大宗奖品必须在3天内送至客户指定地点，你觉得能做到吗？"
                    },
                    {
                        t: 1,
                        d: "唔……这个听上去不错，但可行性上我还真得想想。"
                    }
                ]
            },
            "20011": {
                id: 20011,
                profilePhoto: "wln-photo",
                name: "王立娜",
                title: "现代年轻人的需求潮流",
                state: 0,
                List: [{
                        t: 2,
                        d: "领导，我昨天和几个朋友探讨了一下酒店服务的理念，他们给了一些想法，我觉得不错。"
                    },
                    {
                        t: 1,
                        d: "唔，不错，说来听听。"
                    },
                    {
                        t: 2,
                        d: "来我们酒店消费的人群越来越趋向年轻化，所以我觉得需要用心满足顾客的健身和社交需求。"
                    },
                    {
                        t: 1,
                        d: "这的确是现在年轻人比较喜欢的。"
                    },
                    {
                        t: 2,
                        d: "我想是不是能利用酒店的一些空间转角，设计一些交流区，或者是迷你健身区，让年轻的顾客可以随时锻炼，或能将简易的健身器材借回客房锻炼？"
                    },
                    {
                        t: 1,
                        d: "唔……这个想法听上去很有创意，而且对空间和成本的要求不高。"
                    }
                ]
            },
            "20012": {
                id: 20012,
                profilePhoto: "man-photo",
                name: "餐饮经理",
                title: "客户抱怨酒店餐厅的口味不好",
                state: 0,
                List: [{
                        t: 1,
                        d: "最近客户对酒店餐厅的评分有点低，这是怎么回事？"
                    },
                    {
                        t: 2,
                        d: "哦，关于这个，我问过几个关系不错的老客户，他们说不是餐厅的东西质量下降了，而是那么多年没变过口味，实在是有点吃腻了。"
                    },
                    {
                        t: 1,
                        d: "那你有什么应对措施吗？"
                    },
                    {
                        t: 2,
                        d: "引进新的大厨，搞创新菜色，加强餐厅服务水平，用这个方法来提升满意度。"
                    },
                    {
                        t: 1,
                        d: "嗯，能具体说说你的方案么？"
                    },
                    {
                        t: 2,
                        d: "现在有不少酒店推出自己的餐饮品牌，有顾客就是冲着酒店的餐厅去消费的。我们的食材并不差，如果菜色和口味上略作改变或许会起到意想不到的效果，也能打造新的品牌效应。"
                    }
                ]
            },
            "20013": {
                id: 20013,
                profilePhoto: "man-photo",
                name: "朋友",
                title: "同类型酒店的服务体验分享",
                state: 0,
                List: [{
                        t: 1,
                        d: "上个月出去旅游，感觉怎么样？体验好不好？"
                    },
                    {
                        t: 2,
                        d: "真心不错！景色就不谈了，光说住的那家酒店就让我印象超级深刻！"
                    },
                    {
                        t: 1,
                        d: "来来来，和我说说，到底哪里让你觉得好？"
                    },
                    {
                        t: 2,
                        d: "酒店的服务非常贴心、到位。怎么说呢，我感觉就是服务的超满足性。它不仅能达到我的期待，甚至会超出期望值。"
                    },
                    {
                        t: 1,
                        d: "能举个例子给我听听吗？"
                    },
                    {
                        t: 2,
                        d: "比如说客房送餐服务吧，通常酒店的做法是餐具摆在餐盘上，但他们是把餐具放在一个草编的餐盒里，还装有两套适合饮用不同饮料的杯子，男女各一套。既卫生，又雅致！"
                    }
                ]
            },
            "20031": {
                id: 20031,
                profilePhoto: "man-photo",
                name: "黎启",
                title: "领导，不好意思，我今天在外面",
                state: 0,
                List: [{
                        t: 1,
                        d: "在吗？"
                    },
                    {
                        t: 1,
                        d: "来一下我的办公室。"
                    },
                    {
                        t: 2,
                        d: "额，领导，不好意思，我今天在外面......"
                    },
                    {
                        t: 1,
                        d: "今天收到你的邮件，说实话我非常惊讶。为什么突然想要离开呢？"
                    },
                    {
                        t: 2,
                        d: "可能是我的性格不太适合团队的节奏吧。我觉得这份工作压力挺大的，一有压力我就紧张，一紧张就容易犯错误......"
                    }
                ]
            },
            "20041": {
                id: 20041, profilePhoto: "man-photo", name: "同事", title: "出主意，加工资", state: 0, List: [
                    { t: 1, d: "听说你们黎启要离职？" },
                    { t: 2, d: "……" },
                    { t: 2, d: "什么八卦都逃不过你的耳朵！" },
                    { t: 1, d: "那当然！" },
                    { t: 1, d: "怎么回事？" },
                    { t: 2, d: "小伙子觉得工作压力太大，撑不住……" },
                    { t: 1, d: "啧啧啧，是嫌这里工资太低吧？黎启他们进来的时候工资都被压得死死的，后来也没涨过多少。和他同期进酒店的年轻人都已经走光了吧……" }
                ]
            },
            "30000": {
                id: 30000,
                title: "关于酒店淡季促销活动，需要关注以下几点…",
                state: 0,
                data: [
                    "关于酒店淡季促销活动，要关注执行推进，尤其是沟通宣传方面，客户需要明确地知道我们酒店到底有哪些活动。",
                    "你要和小高一起合作，官网、微博、微信等平台要好好宣传，旅行社那边也要打点好，把我们的促销信息与客户分享，最好是能建立分享奖励机制，吸引客户自主传播。",
                    "另外，安排人在酒店周边的社区、写字楼、商务中心等进行宣传。还有，要动员酒店的员工进行全员销售，奖励机制也要跟上，不过由于成本原因，你要好好想想采用什么方式激励大家。"
                ]
            },
            "30001": {
                id: 30001,
                title: "上次开会说到的积分兑奖，大家都很喜欢…",
                state: 0,
                data: [
                    "上次开会时提到的积分兑奖形式，大家都很喜欢，我觉得既然要做，就要把这个活动做出特色来。",
                    "我的想法是，客户一旦提出兑换，小宗奖品即时兑换，大宗奖品必须在3天内送至客户指定地点。我知道这对我们来说有点难度，所以需要各部门的积极配合，你应该会帮忙吧？"
                ]
            },
            "30002": {
                id: 30002,
                title: "客户总不满意，我也不知道问题出在哪里，头疼…",
                state: 0,
                data: [
                    "我觉得我们做得挺好的，可客户总是不满意。是不是我们的服务人员都比较年轻的原因？比方说，我已经发现有些员工做起事来比较自我中心，或者粗心大意等等。",
                    "还有呀，领导，您之前提到关于酒店淡季促销的事情，我这次短途游的时候发现，外面同类型酒店房价要比我们这儿低上20%左右，您说要不要我们也降降价？"
                ]
            },
            "30003": {
                id: 30003,
                title: "领导，近两年来会务预定的订单分析发给您了，我觉得…",
                state: 0,
                data: [
                    "领导，我把近两年来会务预定的订单做了分析。我们会务的顾客群主要是政府机关和大企业等。",
                    "虽然有同类酒店，但我们的地理位置在风景区，是集旅游、休闲、度假和商务会议功能于一体的，所以比较占优势。",
                    "另外，往常我们会务在年初和年底会是订单高峰期，所以这次淡季我提议能否主推度假商务会议为卖点？"
                ]
            },
            "30004": {
                id: 30004,
                title: "嘿，你来看看，我找到了一家不错的供应商，又便宜又好…",
                state: 0,
                data: [
                    "你快来看看，我找到了一家供应商，他们的产品很不错，又便宜又好看，还非常时尚。我们酒店里的软装要不用这家的，怎么样？",
                    "预算这方面，我可以先出一版草案，到时候你帮着我一起去和总经理说说？"
                ]
            },
            "30010": {
                id: 30010,
                title: "在数据为王的时代，对老客户更需要体现出…",
                state: 0,
                data: [
                    "刚才给你转了篇微博推送，建议抽空看一下，有些点说得很有道理，而且的确是能够给我们启发。",
                    "它有提到关于顾客信息的利用，数据时代就要用数据来说话，对于老客户我们要牢牢抓住，要提升服务的细致程度来让他们对我们满意。",
                    "入住过的顾客，再次入住时，他们的名字、喜好、饮食习惯都不再需要重复询问。这个理念与我们的价值观很相符。"
                ]
            },
            "30011": {
                id: 30011,
                title: "公众号上有篇酒店服务体验的内容很不错…",
                state: 0,
                data: [
                    "我在公众号上发了一篇关于酒店个性化服务的内容，分享给你看看。",
                    "我觉得传统的酒店力求提供100%的满意，但从现在的营销理论来看，即使客户达到完全满意后，出于猎奇的心理，他们还有很大可能转换别的酒店",
                    "为了使顾客成为某一品牌的忠实拥护者，就必须有100%+N%的满意度，N%就是意外的惊喜，超值的享受，让他们觉得你的服务超过了他们的期待。"
                ]
            },
            "30012": {
                id: 30012,
                title: "加速数字化和智能化，让消费者体验更好…",
                state: 0,
                data: [
                    "领导，现在我们的入住顾客中，年轻人比例越来越高，我觉得智能手机在酒店体验中的角色会越来越重要。",
                    "有调研显示，当酒店使用新科技时，66%的消费者会觉得体验更好，不论是订房、客房服务还是与服务人员的互动，年轻人会更习惯用APP或者各种社交媒体应用来完成。",
                    "我建议可以研发一款APP，包括手机门卡、智能预订、个性客房设定的功能等。"
                ]
            },
            "30013": {
                id: 30013,
                title: "我们应该设法满足宾客要求，不论何种诉求…",
                state: 0,
                data: [
                    "从客户意见簿中的留言不难看出，顾客对于我们的服务不论是响应速度还是质量都不太满意，我觉得可以从这两个方面入手。",
                    "建议可以通过培训提升员工服务素养，并且加强正确服务理念的宣导：顾客是上帝，不论他们提出什么诉求，我们都应该设法满足。"
                ]
            },
            "30014": {
                id: 30014,
                title: "建议机器人进入酒店业，用来提高人员效率…",
                state: 0,
                data: [
                    "你看，现在已经有很多五星级的高端酒店采用了智能机器人。",
                    "用智能机器人来提升服务体验流程和我们的服务速度，我个人觉得这个想法很有意思啦，毕竟有些重复性的工作，用人力来完成反而有可能会出错，但机器人只要设置好程序就会严格执行了，不知道你怎么看？"
                ]
            },
            "30030": {
                id: 30030,
                title: "你先找黎启问问情况…",
                state: 0,
                data: [
                    "你先找黎启问问情况，尽量快点解决。",
                    "记得啊，千万别拖延，不要影响团队其他人的情绪。"
                ]
            },
            "30031": {
                id: 30031,
                title: "我们和黎启合作过几次，这个人的工作态度…",
                state: 0,
                data: [
                    "我们和黎启合作过几次，这个人的工作态度有点问题，从来不会主动去配合其他人的工作，每次都得靠别人催。",
                    "合同续约这么重要的事，他不去跟进，现在捅出天大的篓子！我建议你好好考察一下他的工作表现，如果总是这样，还不如让他走吧。"
                ]
            },
            "30032": {
                id: 30032,
                title: "黎启是不是最近发生什么事了？我印象中他…",
                state: 0,
                data: [
                    "黎启？我觉得他很好啊，挺开朗的一个人，也很有想法。比如他上次提出的那几个提升客户满意度的方案，效果都很不错。",
                    "我印象中他不是个粗枝大叶的人，怎么会犯这种错误？是不是最近发生什么事了？"
                ]
            },
            "30033": {
                id: 30033,
                title: "领导，我们所有人都忙得人仰马翻了。至于黎启平时的表现…",
                state: 0,
                data: [
                    "领导，我们所有人都忙得人仰马翻了。魏丽马上要去休产假，如果黎启离职，其他人的工作压力就太大了。",
                    "我观察过小黎他平时工作表现还是不错的。"
                ]
            },
            "30034": {
                id: 30034,
                title: "压力大想辞职？一定是因为…",
                state: 0,
                data: [
                    "压力大想辞职？别是在外面找到新工作了吧。",
                    "能不能劝劝你的手下再待一段时间，这时候走人不厚道吧。"
                ]
            },
            "31001": {
                id: 31001,
                title: "网约房的事情能不能解决，今年的特价房活动…",
                state: 0,
                data: [
                    "对了，网约房的事情你们什么时候处理？如果这个问题没有解决的话，今年淡季还搞什么特价房的促销活动啊！"
                ]
            },
            "31004": {
                id: 31004,
                title: "我把酒店软装更新的计划和总经理提了，他说…",
                state: 0,
                data: [
                    "唉……我把酒店软装更新的计划和秦总提了，他的态度似乎不是很支持，觉得要花50万有点多了，你说怎么办？"
                ]
            },
            "32000": {
                id: 32000,
                title: "方案我看过了，想法不错…",
                state: 0,
                data: [
                    "嗯，方案我已经看过了，想法是不错，虽然也需要资金投入，但还在可控范围内。",
                    "不过，战略性结盟没有想象得那么容易，周围的几家旅行社都处于观望状态，出租车公司这边我可以帮你先去探探路，有几家的老总和我比较熟，姑且试试看吧。"
                ]
            },
            "32003": {
                id: 32003,
                title: "方案我喜欢，互利互惠，现在不是都在讲…",
                state: 0,
                data: [
                    "领导，这个方案我很喜欢啊，互利互惠，现在不是都在讲要打造共赢的生态圈嘛，反正我和我的团队会全力支持的。"
                ]
            },
            "33000": {
                id: 33000,
                title: "我觉得挺不错的，如果能够调动全体员工的积极性…",
                state: 0,
                data: [
                    "这个方案我觉得也挺不错的，如果能调动全体员工的积极性，酒店上下拧成一股绳，不怕销量上不去。"
                ]
            },
            "33001": {
                id: 33001,
                title: "对于客户回访的想法我很有兴趣，如果…",
                state: 0,
                data: [
                    "你这个方案里要进行客户回访是吗？这块的数据我有兴趣，如果想执行的话，我团队上可以出人帮忙一起来做。"
                ]
            },
            "34001": {
                id: 34001,
                title: "你提的这个方案真是打动我心…",
                state: 0,
                data: [
                    "你提的这个方案真是打动我心，要做就做和别人不一样的，这样才能把我们的品牌打出来！"
                ]
            },
            "34002": {
                id: 34002,
                title: "小礼品要做到即时，客户会来前厅询问，但是…",
                state: 0,
                data: [
                    "对了，上次高经理和我说小礼品要做到即时兑换。一般来说，客户都是直接到前厅来询问，但这块是需要各部门配合的，如果货仓没备货，我们也变不出来啊。"
                ]
            },
            "34004": {
                id: 34004,
                title: "促销方案听上去很吸引人，对于我们工程部来说…",
                state: 0,
                data: [
                    "促销方案里的酒店活动听上去很吸引人，名字也起得好听，谁想的？",
                    "不过对我们工程部来说，要帮你们搞定所有设施设备不出差错，唔……让我想想，方法也是有的，就是我们要忙起来啦，哈哈！"
                ]
            },
            "35000": {
                id: 35000,
                title: "想重点关注会务方面，我们酒店的确有一定优势…",
                state: 0,
                data: [
                    "我理解你想重点关注会务这块，我们酒店的确在商务团队接待上有一定优势，不过我有点担心能否在年中找到大量的商务需求。",
                    "看到你这么有信心，我也放心啦，加油干！遇到问题的话，我随时可以做大家的后盾！"
                ]
            },
            "35002": {
                id: 35002,
                title: "商务会议的推广方案，我很支持的，毕竟…",
                state: 0,
                data: [
                    "关于商务会议的推广方案，我很支持啊，立娜姐毕竟是这里的老员工，对酒店的卖点抓得很准。"
                ]
            },
            "35003": {
                id: 35003,
                title: "谢谢领导采纳了我的想法，其实我有和其他伙伴聊过…",
                state: 0,
                data: [
                    "谢谢领导采纳我的想法，我其实也和餐饮、前厅、营销等部门的伙伴们聊过，他们也支持优化现在的沟通流程。但执行细节上还需探讨，毕竟之前的合作流程已经比较固化了，改动还需要磨合一阵子。"
                ]
            },
            "41002": {
                id: 41002,
                title: "这个方案还真是蛮有新意的…",
                state: 0,
                data: [
                    "【星星眼】智能机器人和App的方案很有意思，可以节省掉很多前台的工作，另外也体现出酒店智能化。"
                ]
            },
            "41004": {
                id: 41004,
                title: "你听说了没？XX酒店的智能机器人的事儿…",
                state: 0,
                data: [
                    "唉，你听说没？XX酒店的机器人管家出事了，把一个VIP客户的重要文件给损坏了。据说这个客户还是记者，立马把那家酒店的问题曝光了。",
                    "刚路过总经理办公室，秦总还叫住我讨论呢，说机器人毕竟不如人来得灵活变通。他觉得APP还不错，但机器人么，可能要再考虑一下。"
                ]
            },
            "42000": {
                id: 42000,
                title: "情感消费的时代要重视消费者的内心充实度…",
                state: 0,
                data: [
                    "现在是情感消费时代，消费者更重视心灵的充实而非物质上的噱头。",
                    "我们要以酒店的价值观为基础，把打造极致休闲体验的理念放在首位，全方位设计贴心服务。预算这边我还是有的，不用太束手束脚。",
                    "个性化的服务需要从“细节”入手，员工都需要具备这样的意识，大数据是辅助手段。"
                ]
            },
            "42003": {
                id: 42003,
                title: "想法赞同，但是高素质的人员恐怕不好培养…",
                state: 0,
                data: [
                    "我挺喜欢这个方案的，对于酒店来说，服务的软实力是重要的考核指标，只是我觉得培训一批高素质的服务人员需要的时间不算短呢。"
                ]
            },
            "43000": {
                id: 43000,
                title: "构建健康和人文主题的想法不错，顾客会愿意看到一家不同风格的酒店…",
                state: 0,
                data: [
                    "我觉得构建健康和人文主题是个好想法，本身我们酒店所在位置就有较为良好的自然环境和浓厚的文化底蕴，把这个应用于酒店服务的特色会是不错的升级体验。",
                    "你还记得酒店的价值观吗？将打造极致休闲体验的理念放在首位，全方位设计有特色的服务，预算方面只要合理，我还是会和大老板争取一下的。"
                ]
            },
            "43001": {
                id: 43001,
                title: "从市场部的眼光来说，当然是这个方案最有亮点…",
                state: 0,
                data: [
                    "从市场部的视角来说，当然是这个方案最有亮点，因为它比较容易包装。",
                    "你想想，健康养生、人文底蕴，这两个主题正好能切中现代人的兴趣点，如果能够做好，我个人觉得会很有意思。"
                ]
            },
            "43004": {
                id: 43004,
                title: "我觉得用人文主题搭配健康养生的方案不错…",
                state: 0,
                data: [
                    "我好喜欢酒店用人文主题搭配健康养生的方案，这样我们就与别家酒店那种千篇一律的流水线式服务区分开了。",
                    "而且不论是上了年纪的还是年轻人都会被吸引，就是酒店客房的软装改造，我估计需要一点时间，工期会有点久，你要做好心理准备哦。"
                ]
            },
            "44002": {
                id: 44002,
                title: "安全服务是非常重要的…",
                state: 0,
                data: [
                    "领导，我同意您的想法，酒店的安全服务是非常重要的，最近报道的一起案件，太骇人听闻了，难怪酒店协会对我们提出了这样的要求。"
                ]
            },
            "44003": {
                id: 44003,
                title: "曾经酒店有发生过这样的事情，安全性不容忽视…",
                state: 0,
                data: [
                    "嗯，领导，您提出的这个方案我是大力支持的，安全性对于会务来说真是深有体会。曾经有客户在会议厅遗失过物件，虽是虚惊一场，但也对满意度造成了影响。",
                    "这种事情做好了不见得会提升客户满意度，一旦出事，就是大量的投诉，是我的心病一桩。"
                ]
            },
            "45000": {
                id: 45000,
                title: "建造共享空间，扩大社交、购物和健身机会…",
                state: 0,
                data: [
                    "唔，你这个方案仔细琢磨一下，我觉得也有可取之处。就拿我自己举例子吧，出去旅游，一天待在酒店里，最怕的就是无聊，没有地方可以去消费和娱乐。",
                    "我们酒店周围生态环境不错，就是地理位置稍微有点偏，出行不方便，所以在公共区域增加更多的互动交流机会和休闲空间，这个点子不错。"
                ]
            },
            "45001": {
                id: 45001,
                title: "重塑空间概念这个想法的确不错…",
                state: 0,
                data: [
                    "重塑空间概念这个想法的确不错，既符合当下年轻一代的潮流，又能更好利用酒店大堂空间。",
                    "我觉得大堂一旦具备了集休闲、购物、健身于一体的区域，将会给我们的酒店带来新的活力。"
                ]
            },
            "45004": {
                id: 45004,
                title: "酒店空间的重新设计，这个想法我挺喜欢…",
                state: 0,
                data: [
                    "酒店空间的重新设计，这个想法我挺喜欢的。就是有点担心，一来购物区的成立，对物流和仓储要求挺高，两个环节没匹配好，就容易出岔子。",
                    "二来，迷你健身这个概念，我之前出国的时候看见过，真正的使用率不高，有可能达不到预先设想的效果。"
                ]
            },
            "46002": {
                id: 46002,
                title: "餐厅具有社交功能，做好餐厅服务，会进一步提升口碑…",
                state: 0,
                data: [
                    "除了前厅，餐厅也是酒店里最重要的社交场所之一，如果能够把餐厅的口碑和服务做好，满足所有宾客的需求，会对酒店口碑提升有很大益处。"
                ]
            },
            "46004": {
                id: 46004,
                title: "有些知名酒店就是通过打出自己旗下的餐饮品牌来增加口碑效应…",
                state: 0,
                data: [
                    "作为吃货，我当然是举双手双脚赞成这个方案啦！",
                    "再加上其实有不少酒店就是通过旗下的餐饮品牌来增加口碑，我们的食物也不比他们差，就是缺几个好厨子来料理罢了。"
                ]
            },
            "51000": {
                id: 51000,
                title: "涨薪方案可以考虑…",
                state: 0,
                data: [
                    "涨薪方案可以考虑，但是黎启的表现不足以服众吧？你在选方案的时候还是要考虑一下公平性。"
                ]
            },
            "51004": {
                id: 51004,
                title: "涨薪这办法是挺好的…",
                state: 0,
                data: [
                    "涨薪这办法是挺好的，但是你确定管用？别一转身拿着你开的工资去跟别家谈条件，你花了精力还留不住人。"
                ]
            },
            "52001": {
                id: 52001,
                title: "和黎启只合作过几次，给不出很多意见…",
                state: 0,
                data: [
                    "我们和黎启只合作过几次，给不出太多意见。我只能说，如果我部门有这样的员工，绝、对、不、能、忍。"
                ]
            },
            "52003": {
                id: 52003,
                title: "黎启最近的状态是不太好…",
                state: 0,
                data: [
                    "黎启最近的状态是不太好，但是他之前的表现还是不错的，人聪明、做事也认真，您看我们能不能再给他一次机会？"
                ]
            },
            "53000": {
                id: 53000,
                title: "员工的去留你自己决定…",
                state: 0,
                data: [
                    "我还是那句话，员工的去留你自己决定。不过你有必要去跟他聊聊，了解员工的真实想法很重要。"
                ]
            },
            "53002": {
                id: 53002,
                title: "之前和黎启无意中聊到，他家里似乎发生了一点事情…",
                state: 0,
                data: [
                    "之前和黎启无意中聊到，他家里似乎发生了一点事情；工作上么，他好像和其他部门的同事有点小矛盾，闹得很不愉快，我觉得领导是该跟黎启谈谈心了。"
                ]
            },
            "54000": {
                id: 54000,
                title: "有激励措施当然好…",
                state: 0,
                data: [
                    "有激励措施当然好，不过这些设计的合理性你还是要考虑考虑。",
                    "另外，五万的预算有点多了，有这个必要吗？"
                ]
            },
            "54001": {
                id: 54001,
                title: "团队激励最关键的就是要公平公正…",
                state: 0,
                data: [
                    "团队激励最关键的就是要公平公正，如果在实施这些措施的时候，确实做得到一碗水端平，那这个方案挺好的。如果黎启真的要走，肯定会影响其他人的士气，你最好提前想想要怎么做工作。"
                ]
            },
            "54003": {
                id: 54003,
                title: "激励方案啊？我先看看…",
                state: 0,
                data: [
                    "激励方案啊？我先看看……领导，这个点子真不错，我们早就应该这么做了！"
                ]
            },
            "55002": {
                id: 55002,
                title: "呃，违约金什么的，好像有点不近人情吧…",
                state: 0,
                data: [
                    "呃，违约金什么的，好像有点不近人情吧……不如和黎启商量商量，就算要走，也等我们找到新人再走，我觉得他会答应的。"
                ]
            },
            "55004": {
                id: 55004,
                title: "原来还有培训协议这一招，那你还担心什么…",
                state: 0,
                data: [
                    "原来还有培训协议这一招，那你还担心什么？违约金什么的倒也算了，但至少能让他别在团队最忙的时候离开。"
                ]
            },
            "60000": {
                id: 60000,
                title: "你问我比较看重什么，当然是…",
                state: 0,
                data: [
                    "你问我比较看重什么？身为酒店总经理，我更关心方案的成本是否在可控范围内？方案是否比较容易推进？酒店的业绩能否达到目标？"
                ]
            },
            "60001": {
                id: 60001,
                title: "一个方案要成功，首先得让所有人都接受，毕竟…",
                state: 0,
                data: [
                    "我觉得一个方案要成功，首先得让所有人都接受，毕竟酒店是高度协作的行业，有一环掉了链子都不行！",
                    "还有啊，作为市场营销，方案在市场上的反馈和口碑也是至关重要。"
                ]
            },
            "60002": {
                id: 60002,
                title: "整体团队要能全心全意向共同目标前进…",
                state: 0,
                data: [
                    "唔，我想整个团队能不能全心全意向着共同目标前进，大家的士气能不能保持在高位，这对我来说是要考虑的重点。",
                    "当然，业绩能不能达标，我觉得也很重要！"
                ]
            },
            "60003": {
                id: 60003,
                title: "顾好每一位成员的心情是我的责任…",
                state: 0,
                data: [
                    "身为团队负责人，我会顾好每一位成员的心情。另外我们部门其实和其他部门的关联性比较高，所以得到其他人的支持也是必要的。"
                ]
            },
            "60004": {
                id: 60004,
                title: "做工程的最关心的就是…",
                state: 0,
                data: [
                    "成本是最重要的，其次就是绩效了，反正我做工程的最关心的就是这两样。"
                ]
            },
            "61000": {
                id: 61000,
                title: "我希望看到酒店服务能切实提升客户满意度…",
                state: 0,
                data: [
                    "如果你问我的意见，我会比较希望看到酒店的服务切实地提升了客户满意度，我想我们是有能力把服务做得更加体系化和标准化的。"
                ]
            },
            "61001": {
                id: 61001,
                title: "我个人觉得不要把方案做得太复杂了，毕竟…",
                state: 0,
                data: [
                    "我个人是觉得不要把方案做得太复杂，毕竟我们酒店也是个老牌子，大动干戈反而不美，到时候新客户没留住，老客户反而也不喜欢了。",
                    "而且得到市场的认可相当重要，做酒店行业，最需要的就是口碑宣传了。"
                ]
            },
            "61002": {
                id: 61002,
                title: "领导，我谈谈自己的想法，酒店的服务一定要…",
                state: 0,
                data: [
                    "领导，我谈谈自己的想法，酒店的服务一定要超越普通，达到卓越的标准，这样才能吸引顾客长期留住我们酒店。",
                    "我们现在的服务质量只能说是刚刚达到标准水平，但我不满足于只达到标准，突破平凡才能独树一帜。"
                ]
            },
            "61003": {
                id: 61003,
                title: "我觉得方案在成本上需要…",
                state: 0,
                data: [
                    "唔，我觉得方案在成本上还是要控制一下，虽说以方案为重，预算可以另外争取，但如果投入太多资金，可能会造成周转困难。",
                    "另外呢，我感觉方案不要太复杂，还是需要可操作性高一点。"
                ]
            },
            "61004": {
                id: 61004,
                title: "服务这种东西，你做得再好，客户不认同也是白瞎…",
                state: 0,
                data: [
                    "一定要客户喜欢，服务这种东西，你做得再好，客户不认同也是白瞎，所以要把口碑做好，得到好的反馈。反正我做工程的时候最关心的就是这个。"
                ]
            },
            "62000": {
                id: 62000,
                title: "处理员工问题最要紧的就是…",
                state: 0,
                data: [
                    "处理员工问题最要紧的就是要一碗水端平，别弄得能力好的人越干越累，其他人反而动一动嘴皮子就有甜头尝。",
                    "员工有苦衷、有压力可以理解，但是企业毕竟还是要看个人成果的。"
                ]
            },
            "62001": {
                id: 62001,
                title: "黎启我不熟，不能多做评论…",
                state: 0,
                data: [
                    "黎启我不熟，不能多做评论。但作为一个看重结果的人，我对下属的要求是同样的错误不允许出现两次。如果你做不到，对不起，我只能说你不适合。"
                ]
            },
            "62002": {
                id: 62002,
                title: "我一定是以团队利益为先…",
                state: 0,
                data: [
                    "问我的话，我一定是以团队利益为先的。",
                    "黎启这个年轻人有想法、有活力。领导，给他一些时间吧，我相信他会有改变的。"
                ]
            },
            "62003": {
                id: 62003,
                title: "领导，黎启的问题要解决…",
                state: 0,
                data: [
                    "领导，黎启的问题要解决，但是毕竟马上要到促销季了，VVIP的接待任务工作量又很大，所以，我觉得还是要以业务为重吧。"
                ]
            },
            "62004": {
                id: 62004,
                title: "我其实…",
                state: 0,
                data: [
                    "我其实没什么想法，平时和黎启接触得不多。不过我跟你讲，现在的下属真的不好管，就说我们部门的那谁谁……【挨个点评自己的下属】"
                ]
            },
            "70000": {
                id: 70000,
                title: "几个方案中，我更偏好商务会议推广…",
                state: 0,
                data: [
                    "几个方案中，我更偏好酒店全员促销或者是商务会议推广的方案。"
                ]
            },
            "70001": {
                id: 70001,
                title: "要我选，当然是酒店套餐活动…",
                state: 0,
                data: [
                    "要我选，当然是酒店套餐活动和积分兑奖的方案啦！"
                ]
            },
            "70002": {
                id: 70002,
                title: "我支持立娜姐的方案…",
                state: 0,
                data: [
                    "我支持立娜姐的方案。"
                ]
            },
            "70003": {
                id: 70003,
                title: "我当然是投自己的方案一票…",
                state: 0,
                data: [
                    "我当然是投自己的方案一票，另外就是全员促销的方案，我觉得也不错啊。"
                ]
            },
            "70004": {
                id: 70004,
                title: "我最喜欢的方案就是建立战略性伙伴关系…",
                state: 0,
                data: [
                    "我嘛，我最喜欢的是战略性伙伴那个方案，真让人眼前一亮！"
                ]
            },
            "71000": {
                id: 71000,
                title: "几个方案中，我比较看好其中两个…",
                state: 0,
                data: [
                    "几个方案中，我更看好打造酒店“走心”服务和重塑空间概念，这两个方案挺不错的。"
                ]
            },
            "71001": {
                id: 71001,
                title: "我把方案放到公众号上去让网友投票了，结果…",
                state: 0,
                data: [
                    "我把你的方案隐去细节和酒店名字放到我的公众号上去让网友投票，你想不想看看哪个得分最高？",
                    "从后台统计数据来看，粉丝投票最高的是人文养生主题类型的酒店服务，还有就是提供“走心”的服务。"
                ]
            },
            "71002": {
                id: 71002,
                title: "我喜欢机器人的方案，智能化本身就…",
                state: 0,
                data: [
                    "就个人而言，我喜欢机器人的方案，智能化本身就有着超越标准的意味，APP的概念也很有创意。",
                    "还有，安全性对于我们酒店来说也很重要，千万不能在这上面出岔子！"
                ]
            },
            "71003": {
                id: 71003,
                title: "我觉得领导您提出的“走心”服务很打动我，再来…",
                state: 0,
                data: [
                    "方案上我觉得领导您提出的“走心”服务很打动我。再来的话，我觉得安全性是不能妥协的，这点我和小季都有相同的看法。"
                ]
            },
            "71004": {
                id: 71004,
                title: "我喜欢机器人的这个想法，当然我也赞成…",
                state: 0,
                data: [
                    "我嘛，智能机器人这个主意还是我出的呢，当然最喜欢它啦。",
                    "当然，开几个新的酒店餐饮品牌，我也很赞成，在吃货眼里绝对是食物比天大，哈哈！"
                ]
            },
            "72000": {
                id: 72000,
                title: "这几个方案里面，我觉得你可以先…",
                state: 0,
                data: [
                    "这几个方案里面，我觉得你可以先……唔，找黎启谈谈。另外，团队激励也是个好办法。如果黎启非要现在走，那你也不妨拿出培训协议给他看。"
                ]
            },
            "72001": {
                id: 72001,
                title: "唔，要我选的话…",
                state: 0,
                data: [
                    "唔，要我选的话，肯定让他走人咯。至于人手不够，那就告诉他还有培训协议在身，短期内是走不了的。"
                ]
            },
            "72002": {
                id: 72002,
                title: "领导，我觉得应该…",
                state: 0,
                data: [
                    "领导，我觉得应该多了解下属，就算不是为了绩效问题，多听听年轻人的想法也是好的。",
                    "我觉得团队激励也很重要，多劳多得、奖惩分明，这样大家干起活来才更有积极性啊。"
                ]
            },
            "72003": {
                id: 72003,
                title: "您问我要怎么解决吗…",
                state: 0,
                data: [
                    "你问我要怎么解决吗？嗯，团队激励挺好的，接下来这么忙，额外激励一定对提高团队业绩有帮助。",
                    "至于黎启，我同意要跟他沟通一下，这孩子不错的，就这么放他走了，挺可惜的。"
                ]
            },
            "72004": {
                id: 72004,
                title: "如果你问我的意见，我觉得…",
                state: 0,
                data: [
                    "如果你问我的意见，我觉得还是涨点工资吧。什么压力大、有情绪，工资一涨就没事了。",
                    "实在不行就祭出培训协议咯，白纸黑字在那里，不想留也得留。"
                ]
            },
            "90001": {
                id: 90001,
                name: "高朗",
                isread: false,
                subject: "会议跟进-酒店淡季推广",
                date: "07:34 AM",
                desc: "基于上周的讨论，我做了一版酒店淡季推广方案的<br/>策划海报，请见附件,包括以下两点......",
                content: "基于上周的讨论，我做了一版酒店淡季推广方案的策划海报，请见附件，包括以下两点：<br/><br/>\n" +
                    "                1.\t调整房价的公告设计图 – 指定豪华标间618元/间/晚，豪华大床房 688元/间/晚，开放昭华楼和凌绝楼的房间<br/><br/>" +
                    "                2.\t推出优惠活动的小册子 – 比如说温泉、按摩、熏香、DIY亲子活动等等<br/><br/>" +
                    "                另外，我建议销售部要进行交叉培训，淡季时更要保证人员都经过充分培训，才能应对未来的旺季需求，如果有任何需要市场部门支持的，我会全力配合。<br/><br/>"
            },
            "90002": {
                id: 90002,
                name: "黎启",
                isread: false,
                subject: "辞职信",
                date: "07:58 AM",
                desc: "我仔细想了想，还是决定暂时离开工作岗位一阵子<br/>。正如您之前和我谈到的......",
                content: "   我仔细想了想，还是决定暂时离开工作岗位一阵子。正如您之前和我谈到的，我也觉得自己最近这段时间的工作状态非常不好。<br/><br/>" +
                    "   过去的这两个月内，我的工作总是频频出错，不仅拖了整个团队的后腿，有时候还会给大家制造额外的麻烦。虽然您给了我时间去调整心态，但从现在的反馈来看，我自己也对自己的工作成绩不太满意。<br/><br/>" +
                    "   所以，为了不再给团队抹黑，我正式提出辞职申请，望您能批准。也感谢这一年多来您对我的栽培。<br/><br/>"
            },
            "99100": {
                id: 99100,
                title: "我的想法吗？从个人角度我可以给你一点建议。",
                state: 0,
                data: [
                    "你问我的意见吗？我个人建议你好好想想什么事情是最能够帮助我们酒店提升业绩的，我希望既有短期的快速增长，又不要成为昙花一现。",
                    "另外，我听说你的团队里面现在有些状况，要妥善解决，千万不要在关键时刻掉链子啊。"
                ]
            },
            "99110": {
                id: 99110,
                title: "我的想法吗？从个人角度我可以给你一点建议。",
                state: 0,
                data: [
                    "你问我的意见吗？我个人建议你好好想想什么事情是最能够帮助我们酒店提升业绩的，我希望既有短期的快速增长，又不要成为昙花一现。",
                    "另外，我听说你的团队里面现在有些状况，要妥善解决，千万不要在关键时刻掉链子啊。"
                ]
            },
            "99111": {
                id: 99111,
                title: "淡季销量指标要比去年增加那么多，好难啊！",
                state: 0,
                data: [
                    "总经理和我说要让今年酒店淡季的销量同比去年增长50%，千万不要像去年那样下滑得厉害，拖累了整年的销量指标没能达标。",
                    "但我个人觉得有点难度啊，现在酒店的口碑一直不好不坏的，要激增销量必须要有创新的点子才行。"
                ]
            },
            "99112": {
                id: 99112,
                title: "我这边遇到了一些问题…",
                state: 0,
                data: [
                    "领导，我这里遇到的问题是客户满意度下滑，这个月比上月又下滑了5个百分点。",
                    "其实我们的服务人员都很用心，就是不知道为什么客户不太满意……"
                ]
            },
            "99113": {
                id: 99113,
                title: "领导，我们下两周有商务会议团队要接待，太忙了！",
                state: 0,
                data: [
                    "领导，我们过两周要接待一个VVIP客户团，差不多有30个人，听说他们这次慕名而来，考察我们酒店的服务能否令他们满意。",
                    "但是现在黎启的状态不是很好，魏丽也马上要去休产假了，我们一个人要做两个人的活儿，忙不过来啊！"
                ]
            },
            "99114": {
                id: 99114,
                title: "酒店的硬装一直被客户说老旧，怎么办？",
                state: 0,
                data: [
                    "唉，你说的设备老旧问题，我也和总经理提了好多次了，但是现在酒店预算吃紧，他不批啊。",
                    "我觉得我们应该想个办法，就算酒店硬装陈设不能及时翻新，也得看看怎么改变客户嫌弃老旧过时的状况，比如说软装，或者增加一些实用小物件。"
                ]
            },
            "9510": {
                id: 9510,
                state: 0,
                title: "谈话主题：今天下班要不要一起去踢球？",
                data: ["今天下班要不要一起去踢球，我找到一家很不错的足球场馆，叫上老高一起去！"]
            }
        };
        this.emailModule = {
            "email1": ["10001", "10002", "10003"],
            "email2": ["90001", "90002"],
            "email3": ["10004", "10005"],
            "email4": ["10011", "10012", "10013"],
            "email5": ["10021"]
        };
    }
    emailConfig.prototype.IsCalcList = function (qstId) {
        if (qstId == 0) {
            return true;
        }
        return !([6].indexOf(qstId) > -1);
    };
    emailConfig.prototype.getEmailList = function (keyList, qstId, answer) {
        var returnList = {
            mailList: [],
            mailListHistory: [],
            removeValue: 0,
            unReadCount: 0
        };
        var flag = this.IsCalcList(qstId);
        for (var _i = 0, keyList_1 = keyList; _i < keyList_1.length; _i++) {
            var emailKey = keyList_1[_i];
            var emailItem = this.emailList[emailKey.id];
            if (emailKey.type == 1) {
                emailItem.isread = emailKey.state == 1 ? true : false;
                if (!(qstId == 6 && answer == "1")) {
                    returnList.mailList.push(emailItem);
                }
            }
            else {
                emailItem.isread = emailKey.state == 1 ? true : false;
                returnList.mailListHistory.push(emailItem);
            }
            if (emailItem.isread) {
                returnList.removeValue--;
            }
            else {
                returnList.unReadCount++;
            }
        }
        return returnList;
    };
    emailConfig.prototype.getMessageList = function (keyList, qstId, answer) {
        var returnList = {
            messageList: [],
            messageListHistory: [],
            removeValue: 0,
            unReadCount: 0
        };
        var flag = this.IsCalcList(qstId);
        for (var _i = 0, keyList_2 = keyList; _i < keyList_2.length; _i++) {
            var emailKey = keyList_2[_i];
            var emailItem = this.emailList[emailKey.id];
            if (emailKey.type == 1) {
                emailItem.state = emailKey.state;
                if (!(qstId == 6 && answer == "1")) {
                    returnList.messageList.push(emailItem);
                }
            }
            else {
                emailItem.state = emailKey.state;
                returnList.messageListHistory.push(emailItem);
            }
            if (emailItem.state == 1) {
                returnList.removeValue--;
            }
            else {
                returnList.unReadCount++;
            }
        }
        return returnList;
    };
    emailConfig.prototype.getDiaglogueList = function (dialogObj, keyList, qstId, answer) {
        var returnList = {
            diaglogueList: [],
            diaglogueHistory: [],
            removeValue: 0,
            unReadCount: 0
        };
        var flag = this.IsCalcList(qstId);
        //debugger;
        console.log("======================");
        //清除数据
        for (var i = 0; i < 5; i++) {
            dialogObj[i].unread = 0;
            dialogObj[i].List = [];
            dialogObj[i].History = [];
        }
        for (var _i = 0, keyList_3 = keyList; _i < keyList_3.length; _i++) {
            var emailKey = keyList_3[_i];
            var idStr = emailKey.id + "";
            var lashIndex = parseInt(idStr.substr(idStr.length - 1, 1));
            var emailItem = this.emailList[emailKey.id];
            emailItem.state = emailKey.state;
            if (emailKey.type == 1) {
                if (qstId != 6) {
                    dialogObj[lashIndex].List.push(emailItem);
                }
                else if (emailItem.state == 1)
                    dialogObj[lashIndex].List.push(emailItem);
                if (emailKey.state == 0) {
                    dialogObj[lashIndex].unread += 1;
                }
                else {
                    //dialogObj[lashIndex].unread = 0;
                }
            }
            else {
                if (emailKey.type == 2) {
                    emailItem.state = 1;
                }
                if (emailKey.type == 3) {
                    emailItem.state = 2;
                }
                dialogObj[lashIndex].History.push(emailItem);
            }
            if (emailKey.type != 3) {
                if (emailItem.state == 1) {
                    returnList.removeValue = returnList.removeValue - 2;
                }
                else if (emailKey.type == 1 && qstId != 6 && emailKey.state == 0) {
                    returnList.unReadCount++;
                }
            }
        }
        return returnList;
    };
    return emailConfig;
}());
export { emailConfig };



// WEBPACK FOOTER //
// ./src/app/case-practice-hotel/email-config-component.ts.pre-build-optimizer.js